/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartAnimator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartAnimator";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {GameTweakerTest} from "@nolimitcity/slot-game/bin/dev/tweaker/test/GameTweakerTest";
import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {NudgeSpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelPartAnimator";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {BarbarianFuryBackground} from "./background/BarbarianFuryBackground";
import {BarbarianFuryFontConfig} from "./BarbarianFuryFontConfig";
import {BarbarianFuryGameAssets} from "./BarbarianFuryGameAssets";
import {BarbarianFuryGameConfig} from "./BarbarianFuryGameConfig";
import {BarbarianFurySoundConfig} from "./BarbarianFurySoundConfig";
import {BarbarianFuryBetlineController} from "./betline/BarbarianFuryBetlineController";
import {ForegroundAnimation} from "./foreground/ForegroundAnimation";
import {FreespinsLeftIndicator} from "./freespinsleft/FreespinsLeftIndicator";
import {BFGameShaker} from "./gameshake/BFGameShaker";
import {BFSymbolIdleAnimationController} from "./idleAnimation/symbolIdleAnimation/BFSymbolIdleAnimationController";
import {MultiplierIndicator} from "./multiplier/MultiplierIndicator";
import {BarbarianFuryReelController} from "./reel/reel/BarbarianFuryReelController";
import {BFReelAreaView} from "./reel/reelArea/BFReelAreaView";
import {BFReels} from "./reel/reelArea/BFReels";
import {BurningScatterReelSymbol} from "./reelsymbol/BurningScatterReelSymbol";
import {BurningWildReelSymbol} from "./reelsymbol/BurningWildReelSymbol";
import {BFFreespinIntroController} from "./screens/freeSpinIntro/BFFreespinIntroController";
import {BFFreespinIntroView} from "./screens/freeSpinIntro/BFFreespinIntroView";
import {BFFreespinOutroController} from "./screens/freeSpinOutro/BFFreespinOutroController";
import {BFFreespinOutroView} from "./screens/freeSpinOutro/BFFreespinOutroView";
import {BFReSpinDelayController} from "./screens/reSpinDelay/BFReSpinDelayController";
import {BFScatterNudgeController} from "./screens/scatterNudge/BFScatterNudgeController";
import {BFScatterNudgeView} from "./screens/scatterNudge/BFScatterNudgeView";
import {BarbarianFuryServerDataParser} from "./server/BarbarianFuryServerDataParser";
import {BarbarianFuryParsedGameData} from "./server/data/BarbarianFuryParsedGameData";
import {BarbarianFuryParsedInitData} from "./server/data/BarbarianFuryParsedInitData";
import {BarbarianFurySpinController} from "./spin/BarbarianFurySpinController";
import {BarbarianFuryReelSymbol} from "./symbols/BarbarianFuryReelSymbol";
import {BarbarianFuryReelSymbolStateCreator} from "./symbols/BarbarianFuryReelSymbolStateCreator";
import {BarbarianJailBreak} from "./winpresentation/BarbarianJailBreak";
import {BarbarianFuryBigWinController} from "./winpresentation/bigwin/BarbarianFuryBigWinController";
import {BarbarianFuryIndividualWPController} from "./winpresentation/individual/BarbarianFuryIndividualWPController";
import {BarbarianFuryInitialWPController} from "./winpresentation/initial/BarbarianFuryInitialWPController";
import {BFNudgeStackedWPController} from "./winpresentation/nudgeStacked/BFNudgeStackedWPController";
import {BarbarianFuryWildNudgeWPController} from "./winpresentation/nudgeWild/BarbarianFuryWildNudgeWPController";
import {BFStackedRespinZeroBetController} from "./zeroBet/stackedRespin/BFStackedRespinZeroBetController";
import {FeaturePrice} from "./utils/FeaturePrice";
import {BarbarianFury} from "./BarbarianFury";
import {BarbarianIndividualWinSymCombController} from "./winpresentation/BarbarianIndividualWinSymCombController";

export class BarbarianFuryGameModuleConfig implements IGameModuleConfig {
    public static gameData:BarbarianFuryParsedGameData | null;
    public static instance:BarbarianFuryGameModuleConfig = new BarbarianFuryGameModuleConfig();
    public static reelArea:StillImageBackground;
    public static foregroundAnimation:ForegroundAnimation;
    public static featurePrice: FeaturePrice;

    private static gameTweakerTest:GameTweakerTest;
    private static background:StillImageBackground;

    GAME_CONFIG:IGameConfig = BarbarianFuryGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = BarbarianFurySoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = BarbarianFuryFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = BarbarianFuryGameAssets.RESOURCES_GROUPS;

    SCREENS:(() => ScreenController)[] = [
        () => new BFScatterNudgeController("scatterNudge", {
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new BFScatterNudgeView({
                    layer : BarbarianFuryGameConfig.instance.LAYERS.POP_NUMBERS.name,
                    onButtonClickCallback : onButtonClickCallback,
                    mobileScale : 1,
                    portraitScale : 1
                }, false);
            }
        }),
        () => new BFFreespinIntroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new BFFreespinIntroView({
                    layer : BarbarianFuryGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1,
                    portraitScale : 1

                }, false);
            }
        }),
        () => new BFFreespinOutroController({
            viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                return new BFFreespinOutroView({
                    layer : BarbarianFuryGameConfig.instance.LAYERS.FREESPIN_OUTRO.name,
                    onButtonClickCallback : onButtonClickCallback,
                    buttonBackgroundConfig : {
                        cornerRadius : 12,
                        lineThickness : 2,
                        lineColor : 0xffffff,
                        lineAlpha : 1,
                        backgroundColor : 0x000000,
                        backgroundAlpha : 0.9
                    },
                    mobileScale : 1,
                    portraitScale : 1
                }, false);
            }
        })
    ];
    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new FreespinZeroBetController(),
        () => new BFStackedRespinZeroBetController()
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [
            indexes => new BarbarianFuryWildNudgeWPController(indexes),
            indexes => new BarbarianJailBreak(indexes)
        ],
        [indexes => new BarbarianIndividualWinSymCombController(indexes)],
        [indexes => new BarbarianFuryInitialWPController(indexes)],
        [indexes => new BarbarianFuryBigWinController(indexes)],
        [indexes => new BFNudgeStackedWPController(indexes)],
        [indexes => new BFReSpinDelayController(indexes, {
            name : "BFRespinDelay",
            hasWinCountUp : false,
            skippable : false
        })]
    ];

    /*REEL_STOP_PRESENTATIONS: ((index: number) => ReelStopPresentationController)[] = [
        (index: number) => {
            return new BFReelStopPresentationController(index, "reelStopPresentation")
        }
    ];*/

    constructor() {
        if(BarbarianFuryGameModuleConfig.instance) {
            throw new Error("BarbarianFuryGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    REEL_AREA_VIEW:() => ReelAreaView = () => new BFReelAreaView();
    REELS:() => Reels = () => new BFReels();

    SERVER_PARSER:() => ServerDataParser = () => new BarbarianFuryServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData =
        (data, dataParser:ServerDataParser) => new BarbarianFuryParsedInitData(data, <BarbarianFuryServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData =
        (data, dataParser:ServerDataParser) => new BarbarianFuryParsedGameData(data, <BarbarianFuryServerDataParser>dataParser);

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => new BarbarianFuryReelController(reelId);

    SPIN_CONTROLLER:() => SpinController = () => new BarbarianFurySpinController();

    // REEL_PART_ANIMATOR?:(callbacks:ReelPartAnimatorCallbacks, reelId:number) => NudgeReelPartAnimator; // Default new ReelPartAnimator.
    REEL_PART_ANIMATOR:(id:number) => ReelPartAnimator = (id:number) => new NudgeSpinReelPartAnimator(id);

    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):BarbarianFuryReelSymbol => {
            if(symName.charAt(0) === "W") {
                return new BurningWildReelSymbol(symName, reelId, state);
            }
            if(symName.charAt(0) === "S") {
                return new BurningScatterReelSymbol(symName, reelId, state);
            }
            return new BarbarianFuryReelSymbol(symName, reelId, state);
        });

    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => new BarbarianFuryReelSymbolStateCreator();

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => new BarbarianFuryIndividualWPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0.5;
        }
    });

    GAME_FEATURE_CREATOR:() => void = () => {
        BarbarianFuryGameModuleConfig.gameTweakerTest = new GameTweakerTest();
        StageManager.legacyScaling = false;

        BarbarianFuryGameModuleConfig.background = new BarbarianFuryBackground({
            layer : GameConfig.instance.LAYERS.BACKGROUND.name,
            backgroundImages : {
                NORMAL : {image : BarbarianFuryGameAssets.MAIN_GAME_BACKGROUND, offset : new PIXI.Point(-480, -480)},
                FREESPIN : {image : "bonusBackground", offset : new PIXI.Point(-480, -480)},
                STACKED_RESPIN_FREESPIN : {image : "bonusBackground", offset : new PIXI.Point(-480, -480)}
            },
            stretch : false
        });

        BarbarianFuryGameModuleConfig.reelArea = new StillImageBackground({
            layer : GameConfig.instance.LAYERS.REEL_BACKGROUND.name,
            backgroundImages : {
                NORMAL : {
                    image : BarbarianFuryGameAssets.REEL_BG_MAIN_GAME,
                    offset : new PIXI.Point(-37, 85)
                },
                FREESPIN : {
                    image : BarbarianFuryGameAssets.REEL_BG_BONUS_GAME,
                    offset : new PIXI.Point(-37, 85)
                },
                STACKED_RESPIN_FREESPIN : {
                    image : BarbarianFuryGameAssets.REEL_BG_BONUS_GAME,
                    offset : new PIXI.Point(-37, 85)
                }
            },
            stretch : false
        });
        const multiplier = new MultiplierIndicator();
        const freespinsLeft = new FreespinsLeftIndicator();
        const BetLinesView = new BarbarianFuryBetlineController();
        const gameShaker = new BFGameShaker();
        // TODO: add all features here...

        new BFSymbolIdleAnimationController();
        BarbarianFuryGameModuleConfig.foregroundAnimation = new ForegroundAnimation();
        BarbarianFuryGameModuleConfig.featurePrice = new FeaturePrice();
    };
}